import DialogComponent from "../../../components/DialogComponent";
import Button from "src/components/Button";

type Props = {
    open: boolean;
    toggleDialog: any;
    setOpen: any;
    versionView: any;
    card: any
}

const RemoveDocumentModal = (props: Props) => {

    const { open, toggleDialog, setOpen, versionView, card } = props

    const removeHandle = (params: any) => {
        localStorage.setItem('removeDocument', "true");
    }

    return (
        <DialogComponent open={open} toggleDialog={toggleDialog}>
            <div className="removeDocument max-w-[598px] ">
                <span className="block text-[24px] mb-[18px] leading-7.5 font-semibold">Подтвердите действие</span>
                {versionView &&
                    <span className="block text-[16px] leading-[22px] mb-[38px] break-words">Вы уверены, что хотите удалить эту версию документа <strong>«{card.Title}»</strong>? Все изменения, сделанные в этой версии документа будут удалены.</span>
                    ||
                    <span className="block text-[16px] leading-[22px] mb-[38px] break-words">Вы уверены, что хотите удалить документ <strong>«{card.Title}»</strong>?</span>
                }
                <div className="divide-y mb-[40px] h-px border-t" />
                <div className="flex justify-between">
                    <div className="mr-5">
                        <Button
                            classBg="btn-white"
                            shadow={true}
                            text="Отмена"
                            open={open}
                            setOpen={setOpen}
                        />
                    </div>
                    <div className="ml-5">
                        <Button
                            open={open}
                            setOpen={setOpen}
                            classBg="btn-dark"
                            text={versionView && "Удалить версию" || "Удалить документ"}
                            customFunction={removeHandle}
                            paramsCustomFunction={card.ID}
                            icon={true}
                            typeIcon="remove"
                        />
                    </div>
                </div>
            </div>
        </DialogComponent>
    );
};

export default RemoveDocumentModal;
